import React, {Component} from 'react';

export default class PatientsManagement extends Component {
  constructor(props) {
    super(props);
    this.state = {tab: 'by_patient'};
  }


  selectTab(e, tab) {
    e.preventDefault();
    this.setState({tab});
  }

  renderTabs() {
    let {tab} = this.state;
    let tabs = [
      {id: 'by_patient', label: 'By Patient'},
      {id: 'by_admin', label: 'By Admin'},
    ];

    return (
      <ul className="nav nav-tabs">
        {tabs.map(({id, label}) => {
          let className = tab === id ? 'active' : ''
          return <li key={id} role="presentation" className={className}><a href='#'  onClick={e => this.selectTab(e, id)}>{label}</a></li>
        })}
      </ul>
    )
  }


  renderContent() {
    let {patients} = this.props;
    let {tab} = this.state;
    if (tab === 'by_admin') {
      return <ByAdmin patients={patients} />
    }
    return <ByPatient patients={patients} />
  }
  render() {
    return (
      <div id="patients_management">
        {this.renderTabs()}
        {this.renderContent()}
      </div>
    );
  }
}


class ByPatient extends Component {
  constructor(props) {
    super(props);
    let {patients} = this.props;
    let active_this_week = patients.filter(p => p.active_status === 'w');
    let active_this_month = patients.filter(p => p.active_status === 'm');
    let not_active = patients.filter(p => p.active_status === null);

    this.state = {active_this_week, active_this_month, not_active};
  }

  renderPatient(patient) {
    let lead_admin_name;
    if (patient.lead_admin) {
      lead_admin_name = patient.lead_admin.name;
    }

    let assigned_admin_names = patient.assigned_admins.map(a => a.name).join(', ');
    let link = `/admin/patients/${patient.id}`;
    return (
      <tr key={patient.id}>
        <td><a href={link} target="_blank">{patient.name}</a></td>
        <td>{lead_admin_name}</td>
        <td>{assigned_admin_names}</td>
      </tr>
    )
  }


  renderActiveThisMonth() {
    let {active_this_month} = this.state;

    return(
      <tbody>
        <tr className="header">
          <td>Active this Month</td>
          <td></td>
          <td></td>
        </tr>
        {active_this_month.map(p => this.renderPatient(p))}
      </tbody>
    )
  }


  renderActiveThisWeek() {
    let {active_this_week} = this.state;

    return(
      <tbody>
        <tr className="header">
          <td>Active this Week</td>
          <td></td>
          <td></td>
        </tr>
        {active_this_week.map(p => this.renderPatient(p))}
      </tbody>
    )
  }


  renderNotActive() {
    let {not_active} = this.state;

    return(
      <tbody>
        <tr className="header">
          <td>Not Active</td>
          <td></td>
          <td></td>
        </tr>
        {not_active.map(p => this.renderPatient(p))}
      </tbody>
    )
  }


  render() {
    return (
      <table className="table table-condensed">
        <thead>
          <tr>
            <th></th>
            <th>Lead</th>
            <th>Assigned</th>
          </tr>
        </thead>
        {this.renderActiveThisWeek()}
        {this.renderActiveThisMonth()}
        {this.renderNotActive()}
      </table>
    )
  }
}

class ByAdmin extends Component {
  constructor(props) {
    super(props);
    let admins = groupByAdmin(props.patients);
    let active_admins = admins.filter(a => !a.deactivated);
    let inactive_admins = admins.filter(a => a.deactivated);
    this.state = {active_admins, inactive_admins};
  }


  renderAdmin(admin) {
    let link = `/admin/admins/${admin.id}/edit`
    return (
      <tr key={admin.id}>
        <td><a href={link} target="_blank">{admin.name}</a></td>
        <td className="center"><strong>{admin.active_this_month}</strong><br/>+ {admin.assigned_this_month} support</td>
        <td className="center"><strong>{admin.active_this_week}</strong><br/>+ {admin.assigned_this_week} support</td>
        <td className="center"><strong>{admin.not_active}</strong><br/>+ {admin.assigned_not_active} support</td>
        <td className="center"><strong>{admin.total}</strong><br/>+ {admin.total_assigned} support</td>
      </tr>
    )
  }

  renderActive() {
    let {active_admins} = this.state;
    return (
      <tbody>
        <tr className="header">
          <td>Active Admins</td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
        </tr>
        {active_admins.map(a => this.renderAdmin(a))}
      </tbody>
    )
  }

  renderInactive() {
    let {inactive_admins} = this.state;
    if (inactive_admins.length === 0) return null;

    return (
      <tbody>
        <tr className="header">
          <td>Inactive Admins</td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
        </tr>
        {inactive_admins.map(a => this.renderAdmin(a))}
      </tbody>
    )
  }


  render() {
    return (
      <table className="table table-condensed">
        <thead>
          <tr>
            <th></th>
            <th className="center">Active This Month</th>
            <th className="center">Active This Week</th>
            <th className="center">Not Active</th>
            <th className="center">Total</th>
          </tr>
        </thead>
        {this.renderActive()}
        {this.renderInactive()}
      </table>
    )
  }
}

function groupByAdmin(patients) {
  let admins = [];
  for (let patient of patients) {

    if (patient.lead_admin) {
      let lead_admin = admins.find(a => a.id === patient.lead_admin.id);
      if (!lead_admin) {
        lead_admin = defaultAdmin(patient.lead_admin);
        admins.push(lead_admin);
      }
      if (patient.active_status === 'w') {
        lead_admin.active_this_week++;
      } else if (patient.active_status === 'm') {
        lead_admin.active_this_month++;
      } else {
        lead_admin.not_active++;
      }
    }



    for (let patient_assigned_admin of patient.assigned_admins) {
      let assigned_admin = admins.find(a => a.id === patient_assigned_admin.id);
      if (!assigned_admin) {
        assigned_admin = defaultAdmin(patient_assigned_admin);
        admins.push(assigned_admin);
      }
      if (patient.active_status === 'w') {
        assigned_admin.assigned_this_week++;
      } else if (patient.active_status === 'm') {
        assigned_admin.assigned_this_month++;
      } else {
        assigned_admin.assigned_not_active++;
      }
    }
  }

  for (let admin of admins) {
    admin.total = admin.active_this_month + admin.active_this_week + admin.not_active;
    admin.total_assigned = admin.assigned_this_month + admin.assigned_this_week + admin.assigned_not_active;
  }

  admins.sort((a, b) => b.total - a.total);
  return admins;
}


function defaultAdmin(admin) {
  return {id: admin.id, name: admin.name, deactivated: admin.deactivated, assigned_this_month: 0, assigned_this_week: 0, assigned_not_active: 0, active_this_month: 0, active_this_week: 0, not_active: 0};
}
